/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Metadata related to a Logistics Object, such as information about its creation, about its last update, revision, or its owner.
 * @export
 * @interface LogisticsObjectMetadata
 */
export interface LogisticsObjectMetadata {
    /**
     * The URI of the Logistics Object.
     * @type {string}
     * @memberof LogisticsObjectMetadata
     */
    uri?: string;
    /**
     * Identifier of the member owner of this Logistics Object.
     * @type {string}
     * @memberof LogisticsObjectMetadata
     */
    memberIdentifier?: string;
    /**
     * Revision number incremented after each update of the Logistics Object.
     * @type {number}
     * @memberof LogisticsObjectMetadata
     */
    revision?: number;
    /**
     * Creation date-time (UTC, ISO 8601).
     * @type {Date}
     * @memberof LogisticsObjectMetadata
     */
    createdAt?: Date;
    /**
     * Identifier of the user or system that created the Logistics Object.
     * @type {string}
     * @memberof LogisticsObjectMetadata
     */
    createdBy?: string;
    /**
     * Traceparent for distributed tracing the creation of the Logistics Object.
     * @type {string}
     * @memberof LogisticsObjectMetadata
     */
    creationTraceparent?: string;
    /**
     * Last update date-time (UTC, ISO 8601).
     * @type {Date}
     * @memberof LogisticsObjectMetadata
     */
    updatedAt?: Date;
    /**
     * Identifier of the user or system that last updated the Logistics Object.
     * @type {string}
     * @memberof LogisticsObjectMetadata
     */
    updatedBy?: string;
    /**
     * Traceparent for distributed tracing the last update of the Logistics Object.
     * @type {string}
     * @memberof LogisticsObjectMetadata
     */
    updateTraceparent?: string;
}

/**
 * Check if a given object implements the LogisticsObjectMetadata interface.
 */
export function instanceOfLogisticsObjectMetadata(value: object): value is LogisticsObjectMetadata {
    return true;
}

export function LogisticsObjectMetadataFromJSON(json: any): LogisticsObjectMetadata {
    return LogisticsObjectMetadataFromJSONTyped(json, false);
}

export function LogisticsObjectMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogisticsObjectMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'uri': json['uri'] == null ? undefined : json['uri'],
        'memberIdentifier': json['memberIdentifier'] == null ? undefined : json['memberIdentifier'],
        'revision': json['revision'] == null ? undefined : json['revision'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'creationTraceparent': json['creationTraceparent'] == null ? undefined : json['creationTraceparent'],
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'updateTraceparent': json['updateTraceparent'] == null ? undefined : json['updateTraceparent'],
    };
}

export function LogisticsObjectMetadataToJSON(json: any): LogisticsObjectMetadata {
    return LogisticsObjectMetadataToJSONTyped(json, false);
}

export function LogisticsObjectMetadataToJSONTyped(value?: LogisticsObjectMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uri': value['uri'],
        'memberIdentifier': value['memberIdentifier'],
        'revision': value['revision'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'createdBy': value['createdBy'],
        'creationTraceparent': value['creationTraceparent'],
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'updatedBy': value['updatedBy'],
        'updateTraceparent': value['updateTraceparent'],
    };
}

